import React, { FC } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import { ExtractItem } from "src/utils/extractDescription";
import transactionLabel from "src/utils/transactionLabel";

import {
  ButtonWrapper,
  CloseIcon,
  DownloadIcon,
  InfoModal,
  Modal,
  ModalContent,
  ModalHeader,
  Section,
  SectionAccountinfo,
  SectionCPNJ,
  SectionItem,
  SectionPayerName,
  SectionTitle,
} from "../ModalConfirmOperation/styles";
import toLocaleAmount from "src/utils/toLocaleAmount";
import dateToLine from "src/utils/dateToLine";
import { documentFormatted } from "src/utils/documentFormatted";
import { Button } from "../button";
import { config } from "src/config";
import { useAuth } from "src/hooks/auth";
import { TransferWithPixResponse } from "./ProofResponses";

export const TransferWithPix: FC<{
  data: ExtractItem;
  closeModal: () => void;
}> = ({ data, closeModal }) => {
  const { user } = useAuth();

  const txType = data.type.toLowerCase();

  const naviagate = useNavigate();

  if (!txType.includes("pix")) {
    naviagate("/extract");
  }

  function printPDF() {
    if (!data) return null;

    const receiptString = JSON.stringify(data);

    localStorage.setItem("temp_receipt_to_print", receiptString);

    window.open(`${config.FRONTEND_URL}/PDF`);
  }

  const response = data.response as TransferWithPixResponse;

  const label = transactionLabel(data);

  console.log(response);

  const beneficiaryName = response?.beneficiary?.holder?.name
    ? response?.beneficiary?.holder?.name
    : data.direction == "in"
    ? user.name
    : "Desconhecido";

  return (
    <>
      <ModalHeader>
        <div>
          <span>{label}</span>
          <button onClick={closeModal}>
            <CloseIcon />
          </button>
        </div>
      </ModalHeader>
      <ModalContent>
        <InfoModal>
          <div>
            <span>{response?.beneficiary?.holder?.name}</span>
            <p>R$ {toLocaleAmount(data.amount)}</p>
          </div>
          <span>{dateToLine(data.created_at)}</span>
        </InfoModal>
        <Section>
          <SectionTitle>Pagador</SectionTitle>
          <SectionPayerName>
            <span>NOME</span>
            <p>{response?.payer?.holder?.name}</p>
          </SectionPayerName>
          <SectionCPNJ>
            <span>{response?.payer?.holder?.document?.length > 11 ? "CNPJ" : "CPF"}</span>
            <p>{documentFormatted(response?.payer?.holder?.document)}</p>
          </SectionCPNJ>
          <SectionItem>
            <span>INSTITUIÇÃO</span>
            <p>{response.payer.participant.name}</p>
          </SectionItem>
          <SectionAccountinfo>
            <SectionItem>
              <span>AG</span>
              <p>{response.payer.branch}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response?.payer?.number}</p>
            </SectionItem>
          </SectionAccountinfo>
        </Section>
        <Section>
          <SectionTitle>Favorecido</SectionTitle>
          <SectionItem>
            <span>NOME</span>
            <p>{beneficiaryName}</p>
          </SectionItem>
          <SectionItem>
            <span>{response?.beneficiary?.holder?.document?.length > 11 ? "CNPJ" : "CPF"}</span>
            <p>
              {/* @ts-ignore */}
              {documentFormatted(response.beneficiary.holder.document)}
            </p>
          </SectionItem>
          <SectionItem>
            <span>INSTITUIÇÃO</span>
            <p>{response.beneficiary.participant.name}</p>
          </SectionItem>
          <SectionAccountinfo>
            <SectionItem>
              <span>AG</span>
              <p>{response.beneficiary.branch}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response.beneficiary.number}</p>
            </SectionItem>
          </SectionAccountinfo>
        </Section>
        <ButtonWrapper>
          <Button handleFunction={printPDF} Icon={DownloadIcon} title="Baixar Comprovante" />
        </ButtonWrapper>
      </ModalContent>
    </>
  );
};
